module.exports = __webpack_public_path__ + "img/p1-desc.8c7af0a6.jpg";